const BankingSettings = () => {
	return <div>BankingSettings</div>;
};

export default BankingSettings;
